import axios from 'axios'
// 导入配置文件中的API地址
import { API_BASE_URL } from '../config'
// 创建 axios 实例
const axiosInstance = axios.create({
  baseURL: 'https://service.keepuse.com/import-metafields/api',
  timeout: 5000 // 请求超时时间
})

export function getToken(params) {
  return axiosInstance.post('/auth/generate-token', params)
    .then(response => {
      const data = response.data
      if (data.success) {
        const token = data.data
        // 存储到本地缓存
        localStorage.setItem('token', token)
        // 返回 Promise.resolve() 以表示请求成功
        return Promise.resolve()
      } else {
        // 返回 Promise.reject() 以表示请求失败
        return Promise.reject(data.message)
      }
    })
    .catch(error => {
      // 返回 Promise.reject() 以表示请求失败
      return Promise.reject(error.message || '请求失败')
    })
}

export async function getUserInfo(handle) {
  try {
    const token = localStorage.getItem('token') // 从本地缓存中获取token
    const response = await axios.get(`${API_BASE_URL}/api/users/handle/${handle}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    const data = response.data

    // 判断用户是否存在
    if (data.success) {
      // 用户存在，获取用户信息
      const userInfo = data.data
      return userInfo
    } else {
      // 用户不存在
      throw new Error(data.message)
    }
  } catch (error) {
    // 处理异常情况
    throw new Error(error.message)
  }
}

/**
 * 导入元字段
 * @param {string} fileUrl 文件路径
 * @param {string} handle 操作句柄
 * @returns {Promise<Object>} 导入结果
 * @throws {Error} 请求失败时抛出错误
 */
export async function importMetafields (fileUrl, handle) {
  try {
    const token = localStorage.getItem('token')
    const requestBody = {
      fileUrl: fileUrl,
      handle: handle
    }
    const response = await axios.post(`${API_BASE_URL}/api/excel/import-metafields`, requestBody, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    const data = response.data

    if (data.success) {
      // 请求成功，获取导入结果
      const jsonDataList = data.data
      return jsonDataList
    } else {
      // 请求失败，抛出错误
      throw new Error(data.message)
    }
  } catch (error) {
    // 处理异常情况
    throw new Error(error.message)
  }
}

/**
 * 导出Excel
 * @param {string} handle 操作句柄
 * @returns {Promise<Object>} 导出结果
 * @throws {Error} 请求失败时抛出错误
 */
export async function exportExcel(handle,categoryType) {
  try {
    const token = localStorage.getItem('token')
    const requestBody = {
      handle: handle,
      categoryType: categoryType
    }
    const response = await axios.post(`${API_BASE_URL}/api/excel/export-smart-collection`, requestBody, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    
    const data = response.data
    if (data.success) {
      window.open(data.data, '_blank')
    } else {
      throw new Error(data.message)
    }
  } catch (error) {
    // 处理异常情况
    throw new Error(error.message)
  }
}
/**
 * 导出产品excel
 * @param {*} handle 
 */
export async function exportProductExcel(handle) {
  try {
    const token = localStorage.getItem('token')
    const requestBody = {
      handle: handle
    }
    const response = await axios.post(`${API_BASE_URL}/api/excel/export-product`, requestBody, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    
    const data = response.data
    if (data.success) {
      window.open(data.data, '_blank')
    } else {
      throw new Error(data.message)
    }
  } catch (error) {
    // 处理异常情况
    throw new Error(error.message)
  }
}

/**
 * 批量更新产品
 * @param {string} handle 操作句柄
 * @param {string} fileUrl 文件URL
 * @returns {Promise<Object>} 更新结果
 */
export async function batchUpdateProducts(handle, fileUrl) {
  try {
    const token = localStorage.getItem('token')
    const response = await axios.post(`${API_BASE_URL}/api/product-update/batch`, null, {
      params: {
        handle: handle,
        fileUrl: fileUrl
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error((error.response && error.response.data && error.response.data.message) || error.message)
  }
}

/**
 * 获取任务状态
 * @param {string} taskId 任务ID
 * @returns {Promise<Object>} 任务状态
 */
export async function getTaskStatus(taskId) {
  try {
    const token = localStorage.getItem('token')
    const response = await axios.get(`${API_BASE_URL}/api/product-update/task-status/${taskId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error((error.response && error.response.data && error.response.data.message) || error.message)
  }
}

/**
 * 获取用户任务列表
 * @param {string} handle 操作句柄
 * @returns {Promise<Object>} 任务列表
 */
export async function getUserTasks(handle) {
  try {
    const token = localStorage.getItem('token')
    const response = await axios.get(`${API_BASE_URL}/api/product-update/tasks/${handle}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error((error.response && error.response.data && error.response.data.message) || error.message)
  }
}

/**
 * 批量更新分类
 * @param {string} handle 操作句柄
 * @param {string} fileUrl 文件URL
 * @returns {Promise<Object>} 更新结果
 */
export async function batchUpdateCollections(handle, fileUrl) {
  try {
    const token = localStorage.getItem('token')
    const response = await axios.post(`${API_BASE_URL}/api/collections/batch-update`, null, {
      params: {
        handle: handle,
        fileUrl: fileUrl
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error((error.response && error.response.data && error.response.data.message) || error.message)
  }
}

/**
 * 获取更新日志
 * @param {string} handle 操作句柄
 * @param {Object} params 查询参数
 * @returns {Promise<Object>} 日志列表
 */
export async function getUpdateLogs(handle, params) {
  if (!params) params = {}
  try {
    const token = localStorage.getItem('token')
    const response = await axios.get(`${API_BASE_URL}/api/logs/${handle}`, {
      params: params,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error((error.response && error.response.data && error.response.data.message) || error.message)
  }
}

/**
 * 批量更新商品（异步任务，支持 CSV / Excel 文件。通过 updateType 标识本次是整商品更新还是只更新 tags。
 * @param {string} handle 店铺标识
 * @param {string} fileUrl 文件URL
 * @param {string} updateType  'TAG' 或 'FULL'
 * @returns {Promise<Object>} 任务结果
 */
export async function batchUpdateProductsAsync(handle, fileUrl, updateType) {
  try {
    const token = localStorage.getItem('token')
    const response = await axios.post(`${API_BASE_URL}/api/product-update/batch-async`, null, {
      params: {
        handle: handle,
        fileUrl: fileUrl,
        updateType: updateType || 'FULL'
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error((error.response && error.response.data && error.response.data.message) || error.message)
  }
}

/**
 * 获取用户的商品批量更新任务列表（带分页）
 * @param {string} handle
 * @param {number} page
 * @param {number} size
 * @returns {Promise<Object>}
 */
export async function getProductUpdateTasks(handle, page, size) {
  try {
    const token = localStorage.getItem('token')
    const response = await axios.get(`${API_BASE_URL}/api/product-update/tasks/${handle}`, {
      params: { page: page || 0, size: size || 10 },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error((error.response && error.response.data && error.response.data.message) || error.message)
  }
}

/**
 * 按时间范围获取日志
 * @param {string} handle 操作句柄
 * @param {string} startTime 开始时间
 * @param {string} endTime 结束时间
 * @returns {Promise<Object>} 日志列表
 */
export async function getLogsByTimeRange(handle, startTime, endTime) {
  try {
    const token = localStorage.getItem('token')
    const response = await axios.get(`${API_BASE_URL}/api/logs/${handle}/time-range`, {
      params: {
        startTime: startTime,
        endTime: endTime
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error((error.response && error.response.data && error.response.data.message) || error.message)
  }
}

/**
 * 获取日志统计
 * @param {string} handle 操作句柄
 * @returns {Promise<Object>} 统计信息
 */
export async function getLogStatistics(handle) {
  try {
    const token = localStorage.getItem('token')
    const response = await axios.get(`${API_BASE_URL}/api/logs/${handle}/statistics`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error((error.response && error.response.data && error.response.data.message) || error.message)
  }
}

/**
 * 获取日志详情
 * @param {number} logId 日志ID
 * @returns {Promise<Object>} 日志详情
 */
export async function getLogDetail(logId) {
  try {
    const token = localStorage.getItem('token')
    const response = await axios.get(`${API_BASE_URL}/api/logs/detail/${logId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error((error.response && error.response.data && error.response.data.message) || error.message)
  }
}

/**
 * 清理旧日志
 * @param {string} handle 操作句柄
 * @param {number} daysToKeep 保留天数
 * @returns {Promise<Object>} 清理结果
 */
export async function cleanupOldLogs(handle, daysToKeep) {
  if (!daysToKeep) daysToKeep = 30
  try {
    const token = localStorage.getItem('token')
    const response = await axios.delete(`${API_BASE_URL}/api/logs/${handle}/cleanup`, {
      params: {
        daysToKeep: daysToKeep
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error((error.response && error.response.data && error.response.data.message) || error.message)
  }
}


// WEBPACK FOOTER //
// ./src/api/api.js